import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "agent-chat";

const keys = addTranslations(RESOURCE_NAME, {
    copy: {
        en: "Copy",
        fr: "Copier",
    },
    copied_to_clipboard: {
        en: "Copied to clipboard",
        fr: "Copié dans le presse-papiers",
    },
    ask_me_anything: {
        en: "Ask me anything",
        fr: "Demander n'importe quoi",
    },
    error_message: {
        en: "An unexpected error occurred. Please reload the page.",
        fr: "Une erreur inattendue est survenue. Veuillez recharger la page.",
    },
    error_button_reload: {
        en: "Reload",
        fr: "Recharger",
    },
    empty_state_description: {
        en: "Powered by Ditto",
        fr: "Opéré par Ditto",
    },
    loading: {
        en: "Working on your answer",
        fr: "Je prépare votre réponse",
    },
    uploaded_file: {
        en: "Uploaded file: {{fileName}}",
        fr: "Fichier téléchargé: {{fileName}}",
    },
    tooltip_regenerate: {
        en: "Regenerate",
        fr: "Régénérer",
    },
    tooltip_positive_feedback: {
        en: "Good response",
        fr: "Bonne réponse",
    },
    tooltip_negative_feedback: {
        en: "Bad response",
        fr: "Mauvaise réponse",
    },
    tooltip_upload_file: {
        en: "Add file",
        fr: "Ajouter un fichier",
    },
    file_type_not_supported: {
        en: "File type not supported. As of now, we only support {{acceptedFileTypes}}",
        fr: "Type de fichier non supporté. Pour l'instant, nous ne supportons que {{acceptedFileTypes}}",
    },
});

export function useAgentChatTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
